import React from "react";
import { RenderKilogramo } from "Utils/renderField/renderReadField";
import Badge from "Utils/Badge/Badge";
import { TIPOS_DESTINO_BODEGA_PT } from "../../../../../../../utility/constants";

export const DetallesSobranteTable = ({ salidaDetalle }) => {
    const detalles =
        salidaDetalle && salidaDetalle.detalles_sobrante
            ? salidaDetalle.detalles_sobrante
            : [];

    // TODO: Debería ocultarse cuando no hay datos ? y los detalles normales ??
    if (detalles.length === 0) return null;

    const esReclasificacion =
        salidaDetalle &&
        salidaDetalle.tipo_destino === TIPOS_DESTINO_BODEGA_PT.RECLASIFICACION;

    const esReproceso =
        salidaDetalle &&
        salidaDetalle.tipo_destino === TIPOS_DESTINO_BODEGA_PT.REPROCESO;

    return (
        <React.Fragment>
            <h6 className="text-black mt-4">Kg secos sobrantes despachados</h6>
            <div className="new-table-wrapper boleta-salida__table-wrapper mt-2">
                <table className="table-striped">
                    <thead>
                        <tr>
                            <th>PRODUCTO</th>
                            <th>CONFORME</th>
                            <th>KG SECOS</th>
                            {esReclasificacion && <th>TARJETA</th>}
                            {esReproceso && <th>ALMACÉN DESTINO</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {detalles.map((item) => {
                            return (
                                <tr key={item.id}>
                                    <td className="text-center text-nowrap boleta-salida__table-ellipsis-cell">
                                        {item.producto || "N/A"}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        {item.es_conforme_bodega ? "Sí" : "No"}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <RenderKilogramo
                                            value={item.kg_secos}
                                            decimalScale={2}
                                        />
                                    </td>
                                    {esReclasificacion && (
                                        <td className="text-center text-nowrap">
                                            <Badge
                                                text={`Amarilla - ${item.tarjeta_salida}`}
                                                variant="warning"
                                            />
                                        </td>
                                    )}
                                    {esReproceso && (
                                        <td className="text-center text-nowrap">
                                            {item.bodega_destino_nombre ||
                                                "N/A"}
                                        </td>
                                    )}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </React.Fragment>
    );
};
